import { Component, OnInit, ViewChild } from '@angular/core';
import columnHeader from '../../components/data-grid/model/ColumnHeader';
import { PaginationComponent } from '../../components/pagination/pagination.component';
import { Router } from '@angular/router';
import { CuentasService } from '../../services/cuentas.service';
import { PaletaService } from '../../services/paleta.service';
//import { io } from "socket.io-client";
//import { Socket } from 'ngx-socket-io';

@Component({
  selector: 'app-negociacion',
  templateUrl: './negociacion.component.html',
  styleUrls: ['./negociacion.component.scss']
})
export class NegociacionComponent implements OnInit {
  isDataLoaded:boolean=false
  showModalExtinguir:boolean=false
  headersNegociacion:columnHeader[]=[]
  dataNegociacion:any[]=[]
  listaPaletaGestion:any=[]
  paginationNegociacion:any={
    hasNextPage:false,
    hasPrevPage:false,
    totalPages:[],
    page:0
  }

  @ViewChild("paginationNegociacion",{static:false}) paginadorNegociacion:PaginationComponent;

  constructor(
    private route:Router, 
    private cuentasService:CuentasService,
    private paletaService:PaletaService,
    //private socket: Socket
    ) { 
   
      /*this.socket.on('connect', () => {
        console.log('Conectado a servidor socket')
      });*/

      /*this.socket.emit("enviar-mensaje","PRueba mensaje")

      this.socket.on('enviar-mensaje', (arg) => {
        console.log(arg);
      });*/

      //const socket:any = io("http://localhost:3000");
    
  }

  ngOnInit() {

    /*this.paletaService.getPaleta().subscribe((data:any)=>{
      let paletaTemp:any=[]
      for(let paleta of data.paletas){
        for(let resultado of paleta.resultado_gestion){
          paletaTemp.push({
            id:resultado.id,
            resultado_:paleta._id+"-"+resultado.resultado_gestion
          })
        }
      }
      this.listaPaletaGestion=paletaTemp
    })*/

    this.headersNegociacion = [

      {
        label: "Nro Documento",
        key: "nro_documento",
        subKey:"",
        customClass: "",
        type:""
      },
      {
        label: "Cliente",
        key: "clientes",
        subKey:"nombre",
        customClass: "",
        type:"cliente"
      },
      {
        label: "Cartera",
        key: "asignacion",
        subKey:"",
        customClass: "",
        type:"cartera"
      },
      {
        label: "Producto",
        key: "producto",
        subKey:"",
        customClass: "",
        type:"producto"
      },
      {
        label: "Monto Capital",
        key: "saldo_capital_total",
        subKey:"",
        customClass: "icon-sort", //icon-sort
        type:"money-pre-sum"
      },
      {
        label: "Portafolio",
        key: "portafolio",
        subKey:"",
        customClass: "icon-sort",//icon-sort
        type:"portafolio"
      },
      {
        label: "Gestion en Mes",
        key: "gestiones",
        subKey:"",
        customClass: "",
        type:"gestion"
      },
      {
        label: "Mejor Gestion",
        key: "gestiones",
        subKey:"",
        customClass: "",
        type:"mejor_gestion"
      },
      {
        label: "Acuerdo Pago",
        key: "acuerdo_pago",
        subKey:"",
        customClass: "",
        type:"acuerdo_pago"
      },
      {
        label: "",
        key: "_id",
        subKey:"",
        customClass: "btnIniciar",
        type:"buttonIniciar"
      },
      
    ]

    if(sessionStorage.getItem("perfil")=="Operaciones"){
      this.headersNegociacion.push({
        label: "",
        key: "_id",
        subKey:"",
        customClass: "btnExtinguir",
        type:"buttonExtinguir"
      })
    }
    

    let filter:string="&page=1"

    this.cuentasService.getCuentasByUser(filter).subscribe((data:any)=>{
      if(data.msg=="Peticion invalida"){
          sessionStorage.removeItem("token")
          this.route.navigate(['login'], { })
      }

      let cuentasTemp:any[]=[]
      for(let item of data.cuentas.docs){
          let date1:Date= new Date(item.fecha_vencimiento)
          let date2:Date= new Date()
          item.cliente=item.nombre
          item.mora=this.difference(date1,date2)

          let montoCapitalTotal=parseFloat(item.saldo_capital.$numberDecimal)
          /*for(let itemCuenta of item.cuentas){
            montoCapitalTotal+=parseFloat(itemCuenta.saldo_capital.$numberDecimal)
            
          }*/
          item.saldo_capital_total=montoCapitalTotal
          cuentasTemp.push(item)
      }

      this.dataNegociacion=cuentasTemp
      this.paginationNegociacion.hasNextPage=data.cuentas.hasNextPage
      this.paginationNegociacion.hasPrevPage=data.cuentas.hasPrevPage
      this.paginationNegociacion.totalPages=new Array(data.cuentas.totalPages)
      this.paginationNegociacion.page=data.cuentas.page
      this.paginadorNegociacion.pagParams=this.paginationNegociacion

      this.isDataLoaded=true
    })
  }

  ctaExtinguir:string=""
  extinguirCuenta(row:any){
    this.showModalExtinguir=true
    this.ctaExtinguir=row.cuenta
  }

  confirmarExtinguirCuenta(){
    let dataSend:any={
      cuenta:this.ctaExtinguir
    }
    this.cuentasService.extinguirCuenta(dataSend).subscribe((data:any)=>{
      
      this.ctaExtinguir=""
      this.showModalExtinguir=false
      this.refreshGrid(1)
    })

    
  }

  difference(date1:any, date2:any) {
    const date1utc = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const date2utc = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
    let day:any = 1000*60*60*24;
    return(date2utc - date1utc)/day
  }

  getFecHoy=()=>{
      let hoy:Date = new Date();
 
      let fecha:any = hoy.getDate()+ '/' + ((hoy.getMonth())+1) + '/' + hoy.getFullYear();
      let mes:any=((hoy.getMonth())+1);
      mes=(mes.toString().length==1)?"0"+mes:mes;
      let dia:any=hoy.getDate();
      dia=(dia.toString().length==1)?"0"+dia:dia;
      return hoy.getFullYear()+"-"+mes+"-"+dia
  }

  ngAfterViewInit(): void {

  }

  edit(row:any){

  }

  delete(row:any){

  }

  openModal(row:any){

  }


  sortItem:string="desc"
  sortColumn(row:any){
    if(row.customClass=="icon-sort"){
      //console.log(row)
      if(row.key=="saldo_capital_total"){
        let filter:string="&page=1&sort="+this.sortItem+"&column_sort=saldo_capital"
        this.refreshSort(filter)
      }

      if(row.key=="cuentas"){
        let filter:string="&page=1&sort="+this.sortItem+"&column_sort=portafolio"
        this.refreshSort(filter)
      }
    }
  }

  refreshSort(filter:string){
    this.isDataLoaded=false
    this.cuentasService.getCuentasByUser(filter).subscribe((data:any)=>{
      if(data.msg=="Peticion invalida"){
          sessionStorage.removeItem("token")
          this.route.navigate(['login'], { })
      }

      let cuentasTemp:any[]=[]
      for(let item of data.cuentas.docs){
          let date1:Date= new Date(item.fecha_vencimiento)
          let date2:Date= new Date()
          item.cliente=item.nombre
          item.mora=this.difference(date1,date2)

          let montoCapitalTotal=parseFloat(item.saldo_capital.$numberDecimal)
          /*for(let itemCuenta of item.cuentas){
            montoCapitalTotal+=parseFloat(itemCuenta.saldo_capital.$numberDecimal)
            
          }*/
          item.saldo_capital_total=montoCapitalTotal
          cuentasTemp.push(item)
      }

      this.dataNegociacion=cuentasTemp
      this.paginationNegociacion.hasNextPage=data.cuentas.hasNextPage
      this.paginationNegociacion.hasPrevPage=data.cuentas.hasPrevPage
      this.paginationNegociacion.totalPages=new Array(data.cuentas.totalPages)
      this.paginationNegociacion.page=data.cuentas.page
      this.paginadorNegociacion.pagParams=this.paginationNegociacion
      this.sortItem=(this.sortItem=="desc")?"asc":"desc"
      this.isDataLoaded=true
    })
  }

  goTo(row:any){
    this.route.navigateByUrl(`gestion-cliente/${row.nro_documento}`,{replaceUrl:true})
  }

  refreshGrid(page:any){
    this.isDataLoaded=false
    this.cuentasService.getCuentasByUser("&page="+page).subscribe((data:any)=>{
      let cuentasTemp:any[]=[]
      for(let item of data.cuentas.docs){
          let date1:Date= new Date(item.fecha_vencimiento)
          let date2:Date= new Date()
          item.cliente=item.nombre
          item.mora=this.difference(date1,date2)

          let montoCapitalTotal=parseFloat(item.saldo_capital.$numberDecimal)
          /*for(let itemCuenta of item.cuentas){
            montoCapitalTotal+=parseFloat(itemCuenta.saldo_capital.$numberDecimal)
            
          }*/
          item.saldo_capital_total=montoCapitalTotal
          cuentasTemp.push(item)
      }

      this.dataNegociacion=cuentasTemp
      this.paginationNegociacion.hasNextPage=data.cuentas.hasNextPage
      this.paginationNegociacion.hasPrevPage=data.cuentas.hasPrevPage
      this.paginationNegociacion.totalPages=new Array(data.cuentas.totalPages)
      this.paginationNegociacion.page=data.cuentas.page
      this.paginadorNegociacion.pagParams=this.paginationNegociacion
      this.isDataLoaded=true
    })
  }

  closeModal(){
    this.showModalExtinguir=false
  }

  filterGrid(filter:any){
    this.isDataLoaded=false
    let filterQuery:string=""
    if(filter.target.id=="nro_documento"){
      filterQuery="nro_documento="+filter.target.value
    }

    if(filter.target.id=="nombre_cliente"){
      filterQuery="cliente="+filter.target.value
    }
    
    this.cuentasService.getCuentasByUser("page=1&"+filterQuery).subscribe((data:any)=>{
      let cuentasTemp:any[]=[]
      for(let item of data.cuentas.docs){
          let date1:Date= new Date(item.fecha_vencimiento)
          let date2:Date= new Date()
          item.cliente=item.nombre
          item.mora=this.difference(date1,date2)

          let montoCapitalTotal=parseFloat(item.saldo_capital.$numberDecimal)
          /*for(let itemCuenta of item.cuentas){
            montoCapitalTotal+=parseFloat(itemCuenta.saldo_capital.$numberDecimal)
            
          }*/
          item.saldo_capital_total=montoCapitalTotal
          cuentasTemp.push(item)
      }

      this.dataNegociacion=cuentasTemp
      this.paginationNegociacion.hasNextPage=data.cuentas.hasNextPage
      this.paginationNegociacion.hasPrevPage=data.cuentas.hasPrevPage
      this.paginationNegociacion.totalPages=new Array(data.cuentas.totalPages)
      this.paginationNegociacion.page=data.cuentas.page
      this.paginadorNegociacion.pagParams=this.paginationNegociacion
      this.isDataLoaded=true
    })

   
  }

}
